import React from 'react';

export default class validator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: false,
            datasetEstado: true
        }
        this.validadorInputID = this.validadorInputID.bind(this);
        this.validatorDropDown = this.validatorDropDown.bind(this);
    }

    validadorInputID(id) {
        var count = 1;
        var length = 0;
        var arrayEdit = this.props.elements;
        arrayEdit.map((e) => {
            if (e.id != id) {
                count = count + 1;
            }
            length = length + 1;
        });
        if (count == length) {
            return true;
        } else {
            return false;
        }
    }

    validatorDropDown() {
        var estado = [];
        var arrayEdit = this.props.elements;
        arrayEdit.map((e) => {
            var msj = {}
            if (e.element_id == "DROPDOWNLIST") {
                if (e.table.col_id !== "columna id" && e.table.col_name !== "columna valor" &&
                    e.table.dataset !== "id dataset" && e.table.dataset_name !== "dataset name") {
                    estado.push(<tr><td>{e.id}</td> <td style={{ color: "#4caf50" }}>Set de datos correctamente configurados.</td></tr>);
                } else {
                    this.state.datasetEstado = false;
                    estado.push(<tr><td>{e.id}</td> <td style={{ color: "#e51c23" }}>Debe seleccionar todos los campos correspondientes para un set de datos.</td></tr>);
                }
            }
        });
        return estado;
    }
    render() {
        var countID = 0;
        var estado;
        var validaroID = [];
        var countID = [];
        this.props.elements.map((e, index) => {
            { estado = this.validadorInputID(e.id) }
            {
                (function () {
                    if (estado) {
                        countID.push(1)
                    }
                })()
            }
            {
                estado == false ?
                    validaroID.push(<tbody key={index} style={{ textAlign: "center" }}>
                        <tr key={index}>
                            <td>{e.element_id}</td>
                            <td>{e.id}</td>
                            <td><i className="fa fa-exclamation" aria-hidden="true" style={{ color: "#e51c23" }}></i></td>
                        </tr>
                    </tbody>)
                    : ""
            }
        })
        var dropdown = [];
        dropdown = this.validatorDropDown();
        return (
            <div>
                {
                    validaroID.length != 0 ?
                        <div>
                            <h5>Validando ID's únicos</h5>
                            <table className="table table-striped table-hover ">
                                <thead>
                                    <tr>
                                        <th>Elemento</th>
                                        <th>Id</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>
                                {validaroID}
                            </table>
                        </div>
                        :
                        <div>
                            <h5>Validando id únicos</h5>
                            <p>Id correctamente asignados <i className="fa fa-check" aria-hidden="true" style={{ color: "#4caf50" }}></i></p>
                        </div>
                }
                {dropdown.length === 0 ?
                    ""
                    :
                    <div>
                        <h5>Validando datasets</h5>
                        <table className="table table-striped table-hover ">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dropdown}
                            </tbody>
                        </table>
                    </div>
                }
                <div style={{ marginLeft: "60%" }} className="text-right">
                    <a className="btn btn-success" style={{ cursor: "pointer" }} onClick={() => this.props.publish()} ><i className="fa fa-floppy-o" aria-hidden="true"></i> Publicar</a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/validator.js